import React from "react";
import { Map } from "../../Map";
import { useLoadScript } from "@react-google-maps/api";
import { useSelector } from "react-redux";

export default function ScheduleMap() {
  const technician_locations = useSelector(
    (state) => state.rootReducer.scheduleSlice.technician_locations
  );
  const {lat, lon} = useSelector(
    (state) => state.rootReducer.scheduleSlice.sendData
  );
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBL99kJ-59bryhoVvhKkV6a2JlEFZhQG2I",
  });

  const hasJobCoords =
    lat != null &&
    lon != null &&
    !Number.isNaN(parseFloat(lat)) &&
    !Number.isNaN(parseFloat(lon));

  return (
    isLoaded && (
      <Map
        height={"100%"}
        weight={"100%"}
        data={technician_locations}
        search={
          hasJobCoords ? { lat, lon } : technician_locations?.[0]
        }
        jobLocation={hasJobCoords ? { lat, lon } : undefined}
        zoom={technician_locations?.length ? 8 : 4}
      />
    )
  );
}
